import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);          // user object
  const [status, setStatus] = useState("loading"); // loading | authed | guest

  const fetchMe = useCallback(async () => {
    const tok = localStorage.getItem("sa_token");
    if (!tok) {
      setStatus("guest");
      return;
    }
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
      setStatus("authed");
    } catch {
      localStorage.removeItem("sa_token");
      setStatus("guest");
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    localStorage.setItem("sa_token", data.token);
    setUser(data.user);
    setStatus("authed");
    return data.user;
  };

  const setToken = (tok) => {
    if (tok) {
      localStorage.setItem("sa_token", tok);
      setStatus("authed");
    } else {
      localStorage.removeItem("sa_token");
      setStatus("guest");
    }
  };

  const register = async (name, email, password) => {
    // Now returns { pending_verification, email } — frontend routes to verify step.
    const { data } = await http.post("/auth/register", { name, email, password });
    return data;
  };

  const logout = () => {
    localStorage.removeItem("sa_token");
    // Clear any per-user chat history caches
    try {
      const keys = Object.keys(localStorage);
      keys.forEach((k) => { if (k.startsWith("vidhya_chat_history_v1::")) localStorage.removeItem(k); });
    } catch (e) {}
    setUser(null);
    setStatus("guest");
  };

  return (
    <AuthCtx.Provider value={{ user, status, setUser, setToken, login, register, logout, refresh: fetchMe, refreshMe: fetchMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
